import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';

const setSelectedBlockId = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<string | null>) => {
    state.selectedBlockId = action.payload;
  });

export default setSelectedBlockId;
